/*
Documentation

this is the wrapping component for all auth routes
if a user is already known and logged in it will redirect
them off to their destination

if not destination is know we will redirect to /dashboard

*/

import React, { Component } from "react";
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";
import { Route, Switch } from "react-router-dom";
import routes from "../layout/routes";
import { getUrlParameter } from 'utils/urls';

class Auth extends Component {

    state = {}

    componentDidMount() {

        //if we are not on the logout page
        if(window.location.pathname !== '/auth/logout') {
            const redirect = getUrlParameter('redirect')

            const viewing_user = this.props.viewing_user;

            if(viewing_user && viewing_user.logged_in) {

                // if user is logged in but not staff force a logout
                if(!viewing_user.is_staff) {
                    return window.location.href = '/auth/logout'
                }

                if(redirect) {
                    return this.setState({shouldRedirect: redirect})
                } else {
                    return this.setState({shouldRedirect: '/dashboard/home'})
                }

            }
        }

    }

    componentDidUpdate(e) {

        if (e.history.pathname !== e.location.pathname) {
            document.documentElement.scrollTop = 0;
            document.scrollingElement.scrollTop = 0;

            if(this.refs.mainContent) {
                this.refs.mainContent.scrollTop = 0;
            }
        }

    }
    getRoutes = routes => {
        return routes.map((prop, key) => {

            return (
                <Route
                    path={`/auth${prop.path}`}
                    component={prop.component}
                    key={key}
                />
            );

        });
    };


    getRedirectUrl = () => {
        var getUrl = window.location;
        var baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];

        return baseUrl
    }


    componentDidCatch = (e) => {

        //don't redirect if we are developing
        if(window.location.hostname !== 'localhost') {
            this.setState({shouldRedirect: `/errors/standard?error=${e}&referrerurl=${window.location.href}`})
        }

    }

    render() {

        if(this.state.shouldRedirect) {
            return <Redirect to={this.state.shouldRedirect} />
        }

        return (

        <>
            <div className="layout-auth" ref="mainContent">
                <Switch>{this.getRoutes(routes)}</Switch>
            </div>
        </>
        );
    }
}

const mapStateToProps = state => {
    return {
      viewing_user: state.auth.viewing_user,
    };
};

export default connect(mapStateToProps, '')(Auth);

